import React from 'react';

import mapModifiers from 'utils/functions';

export const iconList = {
  home: 'home',
  homeWhite: 'homeWhite',
  robot: 'robot',
  robotWhite: 'robotWhite',
  setting: 'setting',
  settingWhite: 'settingWhite',
  user: 'user',
  userWhite: 'userWhite',
  invoice: 'invoice',
  invoiceWhite: 'invoiceWhite',
  logout: 'logout',
  logoutWhite: 'logoutWhite',
  paintBrush: 'paintBrush',
  caretDown: 'caretDown',
  plus: 'plus',
  plusBlack: 'plusBlack',
  plusOrange: 'plusOrange',
  minus: 'minus',
  edit: 'edit',
  activeEdit: 'activeEdit',
  trash: 'trash',
  question: 'question',
  eye: 'eye',
  eyeActive: 'eyeActive',
  settingActive: 'settingActive',
  attachment: 'attachment',
  image: 'image',
  send: 'send',
  pencil: 'pencil',
  whitePlus: 'whitePlus',
  blackPrev: 'blackPrev',
  blackNext: 'blackNext',
  tableDelete: 'tableDelete',
  tableEdit: 'tableEdit',
  tableUser: 'tableUser',
  embed: 'embed',
  filter: 'filter',
  whiteFilter: 'whiteFilter',
  aiAction: 'aiAction',
  analytics: 'analytics',
  activeEmbed: 'activeEmbed',
  activeFilter: 'activeFilter',
  aiActionActive: 'aiActionActive',
  analyticsActive: 'analyticsActive',
  global: 'global',
  files: 'files',
  sharePoint: 'sharePoint',
  whiteEdit: 'whiteEdit',
  delete: 'delete',
  google: 'google',
  microsoft: 'microsoft',
  userOrange: 'userOrange',
  bookOrange: 'bookOrange',
  questionOrange: 'questionOrange',
  pie: 'pie',
  pieWhite: 'pieWhite',
  data: 'data',
  dataActive: 'dataActive',
  earth: 'earth',
  earthActive: 'earthActive',
  folder: 'folder',
  folderActive: 'folderActive',
  paperclip: 'paperclip',
  tag: 'tag',
  retry: 'retry',
  addFile: 'addFile',
  close: 'close',
  whiteReload: 'whiteReload',
  whiteMic: 'whiteMic',
  whiteClose: 'whiteClose',
  whiteCircleClose: 'whiteCircleClose',
  blackReload: 'blackReload',
  blackTrash: 'blackTrash',
  blackCopy: 'blackCopy',
  inactiveMic: 'inactiveMic',
  spinner: 'spinner',
  plane: 'plane',
  happy: 'happy',
  sad: 'sad',
  retryCircle: 'retryCircle',
  coppy: 'coppy',
  history: 'history',
  expand: 'expand',
  collapse: 'collapse',
  happyActive: 'happyActive',
  sadActive: 'sadActive',
  blackMic: 'blackMic',
  outlineAddFile: 'outlineAddFile',
  pause: 'pause',
  camera: 'camera',
  recording: 'recording',
  outlineBlackTrash: 'outlineBlackTrash',
  clearImage: 'clearImage',
  chatbotWidget: 'chatbotWidget',
  chatbotWidgetClose: 'chatbotWidgetClose',
  activeAttachClip: 'activeAttachClip',
  activePaperPlane: 'activePaperPlane',
  attachClip: 'attachClip',
  cameraOutline: 'cameraOutline',
  chatBubble: 'chatBubble',
  clock: 'clock',
  grayClose: 'grayClose',
  microphoneOutline: 'microphoneOutline',
  paperPlane: 'paperPlane',
  warning: 'warning',
  copy: 'copy',
  leftArrow: 'leftArrow',
  whiteTrash: 'whiteTrash',
  fileOutline: 'fileOutline',
  expandOut: 'expandOut',
  whiteRetry: 'whiteRetry',
  warn: 'warn',
  check: 'check',
  stop: 'stop',
  globe: 'globe',
  fileUpload: 'fileUpload',
  list: 'list',
  cameraPermission: 'cameraPermission',
  overview: 'overview',
  overviewActive: 'overviewActive',
  customize: 'customize',
  customizeActive: 'customizeActive',
  integration: 'integration',
  integrationActive: 'integrationActive',
  knowledge: 'knowledge',
  knowledgeActive: 'knowledgeActive',
  settings: 'settings',
  settingsActive: 'settingsActive',
  agent: 'agent',
  agentActive: 'agentActive',
  tags: 'tags',
  tagsActive: 'tagsActive',
  customers: 'customers',
  customersActive: 'customersActive',
  x: 'x',
  instagram: 'instagram',
  facebook: 'facebook',
  messenger: 'messenger',
  pinterest: 'pinterest',
  telegram: 'telegram',
  tiktok: 'tiktok',
  website: 'website',
  youtube: 'youtube',
  msSharePoint: 'msSharePoint',
  confluence: 'confluence',
  googleDrive: 'googleDrive',
  internalDatabase: 'internalDatabase',
  uploadFiles: 'uploadFiles',
  crawlWebsite: 'crawlWebsite',
  arrowsClockwise: 'arrowsClockwise',
  authentication: 'authentication',
  authenticationActive: 'authenticationActive',
  instruction: 'instruction',
  instructionActive: 'instructionActive',
  collapseCaretDown: 'collapseCaretDown',
  collapseCaretUp: 'collapseCaretUp',
  zaloOa: 'zaloOa',
  zaloOaActive: 'zaloOaActive',
  webApp: 'webApp',
  webAppActive: 'webAppActive',
  external: 'external',
  caModalWarning: 'caModalWarning',
  roundedCheck: 'roundedCheck',
  roundedError: 'roundedError',
  evolChatWidget: 'evolChatWidget',
  evolCloseWidget: 'evolCloseWidget',
  uploadPhoto: 'uploadPhoto',
};

export type IconName = keyof typeof iconList;

export type IconSize = '12' | '13' | '14' | '16' | '18' | '20' | '20x20' | '22' | '24' | '28' | '30' | '32' | '40' | '48' | '56' | '60' | '64' | '100' | '120' | '80' | 'full';
interface IconProps {
  iconName: IconName;
  size?: IconSize;
  className?: string;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({
  iconName, size, className, style
}) => (
  <i className={`${mapModifiers('a-icon', iconName, size)} ${className || ''}`} style={style} />
);

export default Icon;
